import { render, staticRenderFns } from "./setVr.vue?vue&type=template&id=91bc6fc0&scoped=true"
import script from "./setVr.vue?vue&type=script&lang=js"
export * from "./setVr.vue?vue&type=script&lang=js"
import style0 from "./setVr.vue?vue&type=style&index=0&id=91bc6fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bc6fc0",
  null
  
)

export default component.exports